// @flow

import ExtendableError from 'es6-error';

import Symbol from 'core-js/es6/symbol';

import cuid from 'cuid';

import _ from 'lodash';

const _id = Symbol('_id');

type HowErrorWasHandled = {
	type: 'notification',
	message: string,
} | {
	type: 'validation',
} | {
	type: 'silently',
};

export type ErrorOptions = {
	name?: string,
	code?: string,
	handled?: HowErrorWasHandled,
	response?: ?any,
	userFriendlyMessages?: ?Array<string>,
	correlationIds?: ?Array<string>,
	fileupload?: ?any,
	event?: ?any,
};

export class Error extends ExtendableError {
	name = 'Error';

	id: string;

	code: string = 'RGSRUUI-99099';

	handled: false | HowErrorWasHandled = false;

	response: ?any;
	fileupload: ?Object;
	event: ?any;
	userFriendlyMessages: ?Array<string>;
	correlationIds: ?Array<string>;

	constructor (message: string = '', options?: ErrorOptions) {
		super(message);

		if (options) {
			_.extend(this, _.pickBy(_.pick(options, [
				'name',
				'code',
				'handled',
				'response',
				'fileupload',
				'event',
				'userFriendlyMessages',
				'correlationIds',
			]), Boolean));
		}
	}

	get id (): string {
		if (!(this: Object)[_id]) {
			(this: Object)[_id] = cuid();
		}
		return (this: Object)[_id];
	}
}
